import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

export function MoveIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12 5L12 19"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 17L12 20L15 17"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 7L12 4L9 7"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 12L19 12"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 15L20 12L17 9"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 9L4 12L7 15"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
}
